import React, { useState } from 'react';
import { BsGlobe, BsHdd } from 'react-icons/bs';
import { useCustomer } from './CustomerContext';
import EmptyState from './components/EmptyState';
import { formatDate, daysUntil, formatEur } from '../../utils/api';

// Aviso proactivo de caducidad. Reutiliza las clases cp-badge-* (sin colores inline).
// Vencido -> rojo; 0-30 dias -> ambar; >30 dias o sin fecha -> sin ruido visual.
const RenewalBadge = ({ dateStr }) => {
  const days = daysUntil(dateStr);
  if (days === null) return <span style={{ color: '#94a3b8' }}>{'—'}</span>;
  if (days < 0) return <span className="cp-badge cp-badge-expired">Caducado</span>;
  if (days <= 30) return <span className="cp-badge cp-badge-pendiente">{`Caduca en ${days} días`}</span>;
  return <span style={{ color: '#64748b', fontSize: 12 }}>{formatDate(dateStr)}</span>;
};

// Ordena por fecha_renovacion ascendente; lo que caduca antes va primero.
// Las filas sin fecha quedan al final.
const byRenewalAsc = (a, b) => {
  const da = a.fecha_renovacion ? new Date(a.fecha_renovacion).getTime() : Infinity;
  const db = b.fecha_renovacion ? new Date(b.fecha_renovacion).getTime() : Infinity;
  return da - db;
};

const CustomerInfraPage = () => {
  const { domains, hostings, loading } = useCustomer();
  const [tab, setTab] = useState('domains');

  if (loading) return <div className="cp-skeleton cp-skeleton-card" style={{ height: 300 }} />;

  return (
    <div>
      <h1 className="cp-page-title">Infraestructura</h1>

      <div className="cp-tabs" role="tablist" aria-label="Infraestructura">
        <button
          type="button"
          role="tab"
          id="cp-tab-domains"
          aria-selected={tab === 'domains'}
          aria-controls="cp-panel-domains"
          className={`cp-tab${tab === 'domains' ? ' active' : ''}`}
          onClick={() => setTab('domains')}
        >
          Dominios ({domains.length})
        </button>
        <button
          type="button"
          role="tab"
          id="cp-tab-hosting"
          aria-selected={tab === 'hosting'}
          aria-controls="cp-panel-hosting"
          className={`cp-tab${tab === 'hosting' ? ' active' : ''}`}
          onClick={() => setTab('hosting')}
        >
          Hosting ({hostings.length})
        </button>
      </div>

      {tab === 'domains' && (
        !domains.length ? (
          <EmptyState icon={BsGlobe} title="Sin dominios" subtitle="No tienes dominios registrados." />
        ) : (
          <div className="cp-card-static" role="tabpanel" id="cp-panel-domains" aria-labelledby="cp-tab-domains">
            <div style={{ overflowX: 'auto' }}>
              <table className="cp-table">
                <thead>
                  <tr>
                    <th>Dominio</th>
                    <th>Fecha registro</th>
                    <th>Renovacion</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {[...domains].sort(byRenewalAsc).map(d => (
                    <tr key={d.id}>
                      <td style={{ fontWeight: 500 }}>{d.dominio}</td>
                      <td>{formatDate(d.fecha_registro)}</td>
                      <td>{formatDate(d.fecha_renovacion)}</td>
                      <td><RenewalBadge dateStr={d.fecha_renovacion} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )
      )}

      {tab === 'hosting' && (
        !hostings.length ? (
          <EmptyState icon={BsHdd} title="Sin hosting" subtitle="No tienes servicios de hosting." />
        ) : (
          <div className="cp-card-static" role="tabpanel" id="cp-panel-hosting" aria-labelledby="cp-tab-hosting">
            <div style={{ overflowX: 'auto' }}>
              <table className="cp-table">
                <thead>
                  <tr>
                    <th>Hosting</th>
                    <th>Precio</th>
                    <th>Renovacion</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {[...hostings].sort(byRenewalAsc).map(h => (
                    <tr key={h.id}>
                      <td style={{ fontWeight: 500 }}>{h.hosting}</td>
                      <td>{formatEur(h.precio)}</td>
                      <td>{formatDate(h.fecha_renovacion)}</td>
                      <td><RenewalBadge dateStr={h.fecha_renovacion} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default CustomerInfraPage;
